import store from "@/store";

export default {
  created() {
    let isMoblie = this.$_isMoblie();
    if (isMoblie) store.dispatch("app/setDeviceType", "mobile");
  },
  methods: {
    $_isMoblie() {
      let userAgentInfo = navigator.userAgent;
      return userAgentInfo.indexOf("Windows") < 0;
    }
  }
};
